import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SlideInterfaceModel } from '../../../models/slide.model';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false,
})
export class CardComponent implements OnInit {
  @Input() card: SlideInterfaceModel;
  @Output() cardClicked = new EventEmitter<void>();

  public ngOnInit() {
    if (this.card === undefined) {
      this.card = {
        url: '',
        title: 'Placeholder Title',
        details: 'Placeholder Details',
      };
    }
  }

  onClick() {
    this.cardClicked.emit();
  }
}
